import { axiosInstance } from "../axios";

export const postHeroImage = async (newImageFormData) => {
  await axiosInstance.post(
    `/umbraco/api/MyAccountApi/SubmitHeroImage/`,
    newImageFormData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};
